import React from 'react';
import PropTypes from 'prop-types';

import sanitize from '@helpers/sanitize';
import { AssetTypes } from '@api/v4/assets/assetTypes';
import { CustomFieldsAccordion } from './CustomFieldsAccordion';
import PersonDetails from './personDetails';
import AssetTags from './assetTags';
import AssetPreview from './asset_preview/AssetPreview';


/* NOTE : Anytime you do work in this component make sure there is parity within
the orgSearchResultsAssetDetails component. At some point these should become one
component. Right now they are separated because this component is getting the majority
of it's information from rails, whereas the orgSearchResultsAssetDetails is
getting it's information from an ajax call, which at this point is not sufficient
to receive the information and do all the actions we need */

class AssetDetails extends React.Component {
  get assetBackgroundColor() {
    const backgroundColor = this.props.backgroundColor;
    return backgroundColor && backgroundColor !== "default"
      ? { background: backgroundColor }
      : { backgroundColor: "transparent" };
  }

  renderAssetSpecificDescription() {
    const { asset, assetData } = this.props;

    switch (asset.type) {
      case "Person":
        return (
          <PersonDetails
            email={assetData.email}
            linkedin={asset.linkedin_url}
            name={asset.name}
            phoneNumber={assetData.phone_number}
            title={assetData.title}
            twitter={asset.twitter}
            twitterUrl={asset.twitter_url}
          />
        );
      case "Press":
        return (
          <div className="m-show-description">
            {asset.url ? (
              <a href={asset.url} target="blank">
                {" "}
                {asset.url}
              </a>
            ) : (
              ""
            )}
            {asset.published_date ? <div> {asset.published_date} </div> : ""}
          </div>
        );
      default:
        break;
    }
    return undefined;
  }

  render() {
    const {
      approvedBy,
      asset,
      assetType,
      attachmentKeys,
      awaitingApproval,
      collectionExpiration,
      expired,
      expirationDate,
      formattedDescription,
      isDownloadable,
      publishDate,
      tags,
      threeSixtyViewer,
      unpublished,
      updatedAndCreated
    } = this.props;

    return (
      <>
        <AssetPreview
          asset={asset}
          assetBackgroundColor={this.assetBackgroundColor}
          assetType={assetType}
          attachmentKeys={attachmentKeys}
          isDownloadable={isDownloadable}
          threeSixtyViewer={threeSixtyViewer}
        />
        {!!updatedAndCreated && <div dangerouslySetInnerHTML={{ __html: sanitize(updatedAndCreated) }} />}
        {!!approvedBy && <div dangerouslySetInnerHTML={{ __html: approvedBy }} />}
        {!!awaitingApproval && <div dangerouslySetInnerHTML={{ __html: awaitingApproval }} />}
        {!!collectionExpiration && <div dangerouslySetInnerHTML={{ __html: collectionExpiration }} />}
        {!!publishDate && (
          <div className="s-modal-published-on">
            {`${
              unpublished ? bfTranslate("Will Publish on") : bfTranslate("Published on")
            } ${publishDate}`}
          </div>
        )}
        {!!expirationDate && (
          <div className="s-modal-expires-on">
            {`${expired ? bfTranslate("Expired on") : bfTranslate("Expires on")} ${expirationDate}`}
          </div>
        )}
        {tags.length > 0 && <AssetTags tags={tags} orgSearchPage={false} />}
        {this.renderAssetSpecificDescription()}
        {!!formattedDescription && (
          <div className="m-show-description s-asset-description">
            <span className="s-asset-details-title modal-label">
              {bfTranslate("Description")}
            </span>
            <p dangerouslySetInnerHTML={{ __html: this.props.formattedDescription }} />
          </div>
        )}
        <CustomFieldsAccordion count={6} assetKey={asset.asset_key} />
      </>
    );
  }
}

AssetDetails.propTypes = {
  approvedBy: PropTypes.string,
  asset: PropTypes.shape({
    asset_key: PropTypes.string,
    type: PropTypes.string
  }).isRequired,
  assetData: PropTypes.shape({}),
  assetType: PropTypes.oneOf(Object.values(AssetTypes)).isRequired,
  attachmentKeys: PropTypes.arrayOf(PropTypes.string),
  awaitingApproval: PropTypes.string,
  backgroundColor: PropTypes.string,
  collectionExpiration: PropTypes.string,
  expired: PropTypes.bool.isRequired,
  expirationDate: PropTypes.string,
  formattedDescription: PropTypes.string,
  isDownloadable: PropTypes.bool,
  publishDate: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  threeSixtyViewer: PropTypes.bool,
  unpublished: PropTypes.bool.isRequired,
  updatedAndCreated: PropTypes.string.isRequired
};

AssetDetails.defaultProps = {
  approvedBy: "",
  assetData: {},
  attachmentKeys: [],
  awaitingApproval: "",
  backgroundColor: "",
  collectionExpiration: "",
  expirationDate: "",
  formattedDescription: "",
  isDownloadable: true,
  publishDate: "",
  threeSixtyViewer: false
};

export default AssetDetails;
